import { createSlice } from "@reduxjs/toolkit";

import { IConfigStore } from "../types";

const initialState: IConfigStore = {
  configs: null,
};

export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfigs: (state, { payload }) => {
      state.configs = payload;
    },
  },
});

export const { setConfigs } = configSlice.actions;
